// Maps a value from the domain onto the range, the way d3's scaleLinear does, without pulling d3 in.
export const linearScale =
  ([d0, d1], [r0, r1]) =>
  v =>
    ((v - d0) / (d1 - d0)) * (r1 - r0) + r0
